// extracted by mini-css-extract-plugin
export default {"RemoveParty":"_RemoveParty--ecZGE","Button":"_Button--_n8H3"};